export const GameRules = {
	allowEnteringNetherUsingPortals: 'boolean',
	allowFireTicksAwayFromPlayer: 'boolean',
	announceAdvancements: 'boolean',
	blockExplosionDropDecay: 'boolean',
	commandBlockOutput: 'boolean',
	commandModificationBlockLimit: 'integer',
	disableElytraMovementCheck: 'boolean',
	disablePlayerMovementCheck: 'boolean',
	disableRaids: 'boolean',
	doDaylightCycle: 'boolean',
	doEntityDrops: 'boolean',
	doFireTick: 'boolean',
	doImmediateRespawn: 'boolean',
	doInsomnia: 'boolean',
	doLimitedCrafting: 'boolean',
	doMobLoot: 'boolean',
	doMobSpawning: 'boolean',
	doPatrolSpawning: 'boolean',
	doTileDrops: 'boolean',
	doTraderSpawning: 'boolean',
	doVinesSpread: 'boolean',
	doWardenSpawning: 'boolean',
	doWeatherCycle: 'boolean',
	drowningDamage: 'boolean',
	enableCommandBlocks: 'boolean',
	enderPearlsVanishOnDeath: 'boolean',
	fallDamage: 'boolean',
	fireDamage: 'boolean',
	forgiveDeadPlayers: 'boolean',
	freezeDamage: 'boolean',
	globalSoundEvents: 'boolean',
	keepInventory: 'boolean',
	lavaSourceConversion: 'boolean',
	locatorBar: 'boolean',
	logAdminCommands: 'boolean',
	maxCommandChainLength: 'integer',
	maxCommandForkCount: 'integer',
	maxEntityCramming: 'integer',
	mobExplosionDropDecay: 'boolean',
	mobGriefing: 'boolean',
	naturalRegeneration: 'boolean',
	playersNetherPortalCreativeDelay: 'integer',
	playersNetherPortalDefaultDelay: 'integer',
	playersSleepingPercentage: 'integer',
	projectilesCanBreakBlocks: 'boolean',
	pvp: 'boolean',
	randomTickSpeed: 'integer',
	reducedDebugInfo: 'boolean',
	sendCommandFeedback: 'boolean',
	showDeathMessages: 'boolean',
	snowAccumulationHeight: 'integer',
	spawnMonsters: 'boolean',
	spawnRadius: 'integer',
	spectatorsGenerateChunks: 'boolean',
	tntExplodes: 'boolean',
	tntExplosionDropDecay: 'boolean',
	universalAnger: 'boolean',
	waterSourceConversion: 'boolean',
} as const;
